import { reactive } from "vue";
// Classes
import { InfantClub } from "../classes/InfantClub";

interface State {
	infantClubs: InfantClub[];
	hideClubs: boolean;
}

const state: State = reactive({
	infantClubs: [],
	hideClubs: false,
});

export default state;
